import axios from 'axios';

export const instance = axios.create({
  baseURL: 'https://ecatalog.citra-link.com/api/v1/',
  timeout: 5000,
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
});

export default instance;